/* =====================================================
   ZEHNAZ - zehnaz-sales.js
   ===================================================== */
document.addEventListener('DOMContentLoaded', function () {

  /* -----------------------------------------------
     HERO SLIDESHOW
  ----------------------------------------------- */
  const heroSlides = document.querySelectorAll('.zn-hero-slide');
  const heroDots   = document.querySelectorAll('.zn-hero-dot');
  let heroCurrent  = 0;
  let heroTimer;

  function heroGoTo(n) {
    if (!heroSlides.length) return;
    heroSlides[heroCurrent].classList.remove('active');
    heroDots[heroCurrent] && heroDots[heroCurrent].classList.remove('active');
    
    heroCurrent = (n + heroSlides.length) % heroSlides.length;
    
    heroSlides[heroCurrent].classList.add('active');
    heroDots[heroCurrent] && heroDots[heroCurrent].classList.add('active');
  }

  function heroNext() { heroGoTo(heroCurrent + 1); }
  function heroStart() { heroTimer = setInterval(heroNext, 5500); }
  function heroReset() { clearInterval(heroTimer); heroStart(); }

  heroDots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { heroGoTo(i); heroReset(); });
  });

  if (heroSlides.length > 1) heroStart();


  /* -----------------------------------------------
     WHATSAPP DROPDOWN
  ----------------------------------------------- */
  var waBtn      = document.getElementById('znWaBtn');
  var waDropdown = document.getElementById('znWaDropdown');

  if (waBtn && waDropdown) {
    waBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      waDropdown.classList.toggle('open');
    });

    document.addEventListener('click', function() {
      waDropdown.classList.remove('open');
    });

    waDropdown.addEventListener('click', function(e) { e.stopPropagation(); });
  }


  /* -----------------------------------------------
     DRAG-TO-SCROLL + ARROW BUTTONS
  ----------------------------------------------- */
  function makeDraggable(el) {
    if (!el) return;
    var isDown = false, startX, scrollLeft;

    el.addEventListener('mousedown', function(e) {
      isDown = true;
      el.classList.add('grabbing');
      startX     = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    document.addEventListener('mouseup', function() {
      isDown = false;
      el.classList.remove('grabbing');
    });

    el.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      el.scrollLeft = scrollLeft - (e.pageX - el.offsetLeft - startX);
    });

    el.addEventListener('touchstart', function(e) {
      startX     = e.touches[0].pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    }, { passive: true });

    el.addEventListener('touchmove', function(e) {
      el.scrollLeft = scrollLeft - (e.touches[0].pageX - el.offsetLeft - startX);
    }, { passive: true });
  }

  function setupScroller(scrollerId, prevId, nextId, step) {
    var el   = document.getElementById(scrollerId);
    var prev = document.getElementById(prevId);
    var next = document.getElementById(nextId);
    var px   = step || 276;

    if (!el) return;
    if (prev) prev.addEventListener('click', function() { el.scrollBy({ left: -px, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function() { el.scrollBy({ left:  px, behavior: 'smooth' }); });
    
    makeDraggable(el);
  }

  setupScroller('znPretScroller',  'znPretPrev',  'znPretNext',  276);
  setupScroller('znJewScroller',   'znJewPrev',   'znJewNext',   296);


  /* -----------------------------------------------
     INTERSECTION OBSERVER - FADE-IN CARDS
  ----------------------------------------------- */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.zn-product-card').forEach(function(card) {
    observer.observe(card);
  });


  /* -----------------------------------------------
     QUICK ADD TO CART (Single Product)
  ----------------------------------------------- */
  document.querySelectorAll('.zn-quick-add').forEach(function(btn) {
    if(btn.tagName !== 'BUTTON') return;
    
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      var variantId = btn.getAttribute('data-variant-id');
      var select = btn.previousElementSibling;
      
      if (select && select.classList.contains('zn-variant-select')) {
        if (select.value === "") {
          var origText = btn.textContent;
          btn.textContent = 'Select Size';
          btn.style.background = 'var(--zn-sale-red)';
          setTimeout(function() {
            btn.textContent = origText;
            btn.style.background = '';
          }, 2000);
          return;
        }
        variantId = select.value;
      }
      
      if (!variantId) return;

      var original = btn.textContent;
      btn.textContent = '...';
      btn.style.pointerEvents = 'none';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function(r) { 
        if (!r.ok) throw new Error('Server Error');
        return r.json(); 
      })
      .then(function() {
        btn.textContent = '✓ Added!';
        btn.style.background = '#3a7d44';
        
        setTimeout(function() {
          window.location.href = window.Shopify.routes.root + 'cart';
        }, 500);

      })
      .catch(function() {
        btn.textContent = 'Error';
        btn.style.background = '#c0392b';
        setTimeout(function() {
          btn.textContent = original;
          btn.style.background = '';
          btn.style.pointerEvents = '';
        }, 2500);
      });
    });
  });


  /* -----------------------------------------------
     BUNDLE ADD TO CART (Multi-Item + Discount)
  ----------------------------------------------- */
  var bundleBtns = document.querySelectorAll('.znBundleAddMulti');
  bundleBtns.forEach(function(bundleBtn) {
    bundleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      var box = this.closest('.zn-bundle-box');
      var selects = box.querySelectorAll('.zn-bundle-select');
      var discountCode = this.getAttribute('data-discount');
      var items = [];
      var hasError = false;

      selects.forEach(function(select) {
        if (select.tagName === 'SELECT' && select.value === "") {
          select.style.borderColor = "var(--zn-sale-red)";
          hasError = true;
        } else if (select.value) {
          select.style.borderColor = "var(--zn-border)";
          items.push({ id: parseInt(select.value, 10), quantity: 1 });
        }
      });

      if(hasError) {
        var origText = bundleBtn.textContent;
        bundleBtn.textContent = 'Select Sizes';
        bundleBtn.style.background = 'var(--zn-sale-red)';
        bundleBtn.style.color = '#fff';
        setTimeout(function() {
          bundleBtn.textContent = origText;
          bundleBtn.style.background = '';
          bundleBtn.style.color = '';
        }, 2000);
        return;
      }

      if(items.length === 0) return;
      var origText = this.textContent;
      this.textContent = 'Adding Bundle...';
      this.style.pointerEvents = 'none';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { 
        if (!r.ok) throw new Error('Server Error');
        return r.json(); 
      })
      .then(function() {
        bundleBtn.textContent = '✓ Bundle Added!';
        bundleBtn.style.background = '#3a7d44';
        
        // Redirect explicitly via the discount route to checkout
        setTimeout(function() {
          if (discountCode && discountCode.trim() !== "") {
            window.location.href = window.Shopify.routes.root + 'discount/' + discountCode.trim() + '?redirect=/checkout';
          } else {
            window.location.href = window.Shopify.routes.root + 'checkout';
          }
        }, 500);

      })
      .catch(function(error) {
        bundleBtn.textContent = 'Error';
        bundleBtn.style.background = '#c0392b';
        setTimeout(function() {
          bundleBtn.textContent = origText;
          bundleBtn.style.background = '';
          bundleBtn.style.pointerEvents = '';
        }, 2500);
      });
    });
  });


  /* -----------------------------------------------
     NEWSLETTER SUBSCRIBE (Shopify native)
  ----------------------------------------------- */
  var newsletterForm = document.getElementById('znNewsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = newsletterForm.querySelector('input[type="email"]');
      var btn        = newsletterForm.querySelector('.zn-newsletter-btn');
      
      if (!emailInput || !emailInput.value) return;
      
      var original = btn.textContent;
      btn.textContent = '...';
      
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          form_type: 'customer',
          utf8: '✓',
          'contact[email]': emailInput.value,
          'contact[tags]': 'newsletter'
        })
      })
      .then(function() {
        btn.textContent = '✓ Subscribed!';
        emailInput.value = '';
        setTimeout(function() { btn.textContent = original; }, 3000);
      })
      .catch(function() {
        btn.textContent = original;
      });
    });
  }

  /* -----------------------------------------------
     STICKY HEADER SHADOW
  ----------------------------------------------- */
  var siteHeader = document.querySelector('.shopify-section--header, header.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', function() {
      siteHeader.classList.toggle('zn-scrolled', window.scrollY > 40);
    }, { passive: true });
  }

});